import { Switch, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useDispatch } from "react-redux";

import { updateUserSettingsByUserID } from "actions/userSettings";

import useTheme from "hooks/useTheme";
import useNotification from "hooks/useNotification";

import { BiMoon, BiSun } from "react-icons/bi";
import { RiMoonClearLine } from "react-icons/ri";
import ColorList from "common/colors/ColorList";
import SelectedDotIcon from "theme/icons/SelectedDot";
import { IoSunny } from "react-icons/io5";
import { BsMoonFill, BsMoonStarsFill, BsSunFill } from "react-icons/bs";
import ThemesIcon from "theme/icons/Themes";

const Theme = () => {
	const dispatch = useDispatch();

	const { appLanguage, themeColor, themeMode } = useTheme();
	const { notify } = useNotification();

	const ModesList = [
		{ name: appLanguage?.lightMode, mode: "light", icon: <BiSun /> },
		{ name: appLanguage?.darkMode, mode: "dark", icon: <RiMoonClearLine /> },
	];

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="items-center justify-content w-[50%] flex-col px-5 space-y-2">
				<div className={`flex w-full items-center justify-center space-x-4 py-3`}>
					<p className={`text-md font-bold ${themeColor.text}`}>{appLanguage?.darkMode}</p>
					<Switch defaultChecked={false} onChange={() => notify("info", appLanguage?.comingSoon)} as={Fragment}>
						{({ checked }) => (
							<button
								className={`${
									checked ? themeColor?.bg : `${themeColor?.bg} bg-opacity-20`
								} relative inline-flex h-5 w-10 shrink-0 rounded-full smooth border-2 border-transparent`}
							>
								<BsSunFill className={`absolute left-1 w-3 text-white`} />
								<BsMoonStarsFill className={`absolute right-1 w-3 ${themeColor.text}`} />
								<span
									className={`${
										checked ? "translate-x-5" : "translate-x-0"
									} h-4 w-4 rounded-full bg-white shadow-xl smooth`}
								/>
							</button>
						)}
					</Switch>
				</div>

				<div className={`flex flex-col w-full items-center justify-start space-y-3`}>
					{ColorList.map((colorItem, index) => (
						<div
							className={`flex w-full items-center justify-start space-x-4 cursor-pointer rounded-md border px-4 py-3 ${
								colorItem?.hex === themeColor?.hex && "shadow-md"
							}`}
							key={index}
							onClick={() => {
								dispatch(updateUserSettingsByUserID({ "theme-color": colorItem }, notify));
							}}
						>
							<ThemesIcon className={`w-7`} fill={colorItem?.hex} />
							<p className={`w-full text-sm font-bold ${colorItem?.text}`}>{appLanguage[colorItem.color]}</p>
							{colorItem?.hex === themeColor?.hex && <SelectedDotIcon className={`w-4`} fill={themeColor?.hex} />}
						</div>
					))}
				</div>
			</div>
		</Transition>
	);
};

export default Theme;
